import * as R from "ramda";
import { call, reducer } from "../../helpers/api/meta";
import { getAssessmentById } from "../../helpers/api/api";

export const SELECT_PROCTOR_ASSESSMENT = "SELECT_PROCTOR_ASSESSMENT";

export const saveProctoringAssessment = (id) => {
  const meta = {
    endpoint: () => getAssessmentById(id),
    action: SELECT_PROCTOR_ASSESSMENT,
    messages: {
      id: "saveSelectedAssessment",
      failure: "Could not get proctor detail",
    },
  };
  return call(meta);
};

const initialState = {
  loading: false,
  results: null,
};

const saveSelectedAssessment = (state, action) => {
  return R.assoc("results", action.results, state);
};

const messages = {
  loadFailed: "Could not load proctor detfail.",
};

export default reducer(
  initialState,
  SELECT_PROCTOR_ASSESSMENT,
  saveSelectedAssessment,
  messages.loadFailed
);
